<template>
    <div></div>
</template>

<script>

export default {
    name: `Forbidden`,
    components: {
    },
    data() {
        return {
        }
    },
    methods: {
    },
    mounted() {
    }
}
</script>
